// @ts-strict-ignore
//We have to do this validation since Contentful and NextJs use different locale naming conventions. Also, there is an issue when there is no locale passed to the function, the entry id gets placed as the locale, and this would cause our builds to fail, since the Contentful request will fail because the locale requested will be unknown.

import { LOCALE_TO_CONTENTFUL_LOCALES } from "services/api/dynamic";

export const validateLocale = (locale?: string) => {
  if (!locale) return "en-US";
  const translationLocale = LOCALE_TO_CONTENTFUL_LOCALES[locale] ?? "en-US";

  if (translationLocale === "es-LA") {
    return "es-419";
  }

  return translationLocale;
};
